module.exports = __webpack_public_path__ + "img/ScreenCapture.96f9cc77.png";